import React from 'react';

import './global.css'
import Routes from './routes';
/**
 * Componente: Função que retorna HTML
 * Propriedades: 
 */

function App() {
  return (
   <Routes></Routes>
  );
}

export default App;
